import {
  CONFIG_ADD_NO_OF_DAYS,
    CONFIG_EXPIRE,
    FETCH_SCHEDULAR_SUCCESS,
    FETCH_SCHEDULAR_DAY,
    SCHEDULAR_DAY_EDIT,
    FETCH_SCHEDULAR_EXPIRE_TIME_SUCCESS,
    FETCH_SCHEDULAR_EXPIRE_TIME,
    SCHEDULAR_EXPIRE_TIME_EDIT,
    GET_SESSIONS,
    GET_SESSIONS_SUCCESS,
    CLEAR_SESSIONS,
  } from "../constants/schedular.constants";
  
  export const addConfig = (config_add_no_of_days) => {
    return {
      type: CONFIG_ADD_NO_OF_DAYS,
      config_add_no_of_days: config_add_no_of_days,
    };
  };

  export const expireConfig = (config_expire) => {
    return {
      type: CONFIG_EXPIRE,
      config_expire: config_expire,
    };
  };

  export const getSchedularSuccess = (schedular_day) => {
    return {
      type: FETCH_SCHEDULAR_SUCCESS,
      schedular_day: schedular_day,
    };
  };

  export const getSchedularday = () => {
    return {
      type: FETCH_SCHEDULAR_DAY,
    };
  };

  export const schedularDayEdit = (new_schedular_day) => {
    return {
      type: SCHEDULAR_DAY_EDIT,
      new_schedular_day: new_schedular_day,
    };
  };

  //expire time

  export const getSchedularExpireTimeSuccess = (schedular_expire_time) => {
    return {
      type: FETCH_SCHEDULAR_EXPIRE_TIME_SUCCESS,
      schedular_expire_time: schedular_expire_time,
    };
  };

  export const getSchedularExpireTime = () => {
    return {
      type: FETCH_SCHEDULAR_EXPIRE_TIME,
    };
  };

  export const schedularExpireTimeEdit = (new_schedular_expire_time) => {
    return {
      type: SCHEDULAR_EXPIRE_TIME_EDIT,
      new_schedular_expire_time: new_schedular_expire_time,
    };
  };
  
export const getSessions = (data) => {
  return {
    type: GET_SESSIONS,
    payload: data
  };
}

export const getSessionsSuccess = (data) => {
  return {
    type: GET_SESSIONS_SUCCESS,
    payload: data
  };
}

export const clearSessions = (data) => {
  return {
    type: CLEAR_SESSIONS
  };
}